import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoginService } from 'src/app/Common/Services/login.service';
import { ToastrService } from 'ngx-toastr';
import { PushNotification } from '../Model/pushNotification';
import { logWarnings } from 'protractor/built/driverProviders';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.css']
})
export class PushNotificationComponent implements OnInit {
  notificationForm :FormGroup;
  agentLists: any[] = [];
  notifyList:any[]=[];
pushNotification :PushNotification=new PushNotification();
public agentCtrl: FormControl = new FormControl();

displayedColumns: string[] = ['agentname', 'remarks','response','status'];
dataSource ;
notificationList :PeriodicElement[] =[];

@ViewChild(MatSort, {static: true}) sort: MatSort;
@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
userform:FormGroup;

  constructor(private _formbuilder: FormBuilder,public loginservice:LoginService,private toastr: ToastrService) { 

    this.notificationForm =this._formbuilder.group({
      agentNameList: ['',[Validators.required]],
      remarks: ['',[Validators.required]]
    });

    this.userform =this._formbuilder.group({
      search:['']
    })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit() {
    
    this.getAllLOvs("notification");
    this.getnotificationList();
  }
  getAllLOvs(value:string){
    
    this.loginservice.getPageLOVs(value).subscribe((res:any)=>{
      if(res.responseBody != undefined){
        console.log("LOVs",res.responseBody);
        this.agentLists = res.responseBody.agentList;
      }
    
    })
  }


getnotificationList(){
  
  var loginuser = "1111";
  this.loginservice.getnotificationList(loginuser).subscribe((res:any) => {
    if(res.responseBody != undefined){
      console.log("Listing :", res.responseBody);
      this.notifyList = res.responseBody.getNotifyList;
      console.log("Notify Listing:", this.notifyList)
      this.dataSource = new MatTableDataSource(this.notifyList);
      this.dataSource.paginator = this.paginator;
    }
    
  })
}

  submit(){
    
      var remarks=this.notificationForm.get("remarks").value;
      var loginuser ="1111";
      var agentNameList =this.notificationForm.get('agentNameList').value;
      this.pushNotification.remarks=remarks;
      this.pushNotification.agentNames=agentNameList;
      this.pushNotification.loginuser =loginuser;
      this.loginservice.notification(this.pushNotification).subscribe((res:any)=>{
      
     console.log(res);
     if(res.responseBody.validationMsg){
      this.toastr.success(res.responseBody.validationMsg, undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
      });
      this.getnotificationList();
     }
      })
    this.notificationForm.reset();
  }
}
